import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../../../stores/NavigateStore";


export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
    },
    emptyBox:{
        width: '100%',
        height: `calc(100vh - ${topHeight}px - 36px - 20px - 24px - 24px)`,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& p':{
            fontSize: '1.375rem',
            color: '#87888d',
            fontWeight:400,
            textAlign: 'center',
            lineHeight: '30.36px'
        }
    },
    boxWrap: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
        height: 'calc(100vh - 500px)'
    },
    boxRole: {
        backgroundColor: '#fff',
        padding: '47px 20px',
        borderRadius: 8,
        height: 130,
        marginBottom: 20,
    },
    textBox: {
        '& .MuiBox-root': {
            padding: '10px 0px',
        },
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
            }
        }
    },
    disabled: {
        '& .MuiButtonBase-root': {
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
            '& .MuiTypography-root': {
                color: 'rgba(255, 255, 255, 0.7)',
            }
        },
    },
    buttonStyle: {
        position: 'absolute',
        right: 20,
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 82,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: '#fff',
            }
        },
    },
    formControl:{
        '&.MuiFormControl-root ':{
            margin: 0,
            width: 140,
            marginRight: 12,
        },
        '& .MuiSelect-select':{
            width: 140,
            height: 40,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing:'border-box',
            color:'#777',
            letterSpacing: '-0.5px',
            display:'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px #87888d',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select':{
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':{
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
    typeOption: {
          '&.MuiTypography-root': {
              fontSize: '1.25rem',
              fontWeight: 'bold',
              marginRight: 14,
          }
    },
    textName: {
        '& .MuiFormControl-root': {
            width: 240,
            height: 40,
            boxSizing: 'border-box',
            marginRight: 10,
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
    },
    ListBox: {
        marginBottom: 35,
        '& > div': {
            marginBottom: 10,
        },
        '& > div:last-child': {
            marginBottom: 0,
        },
    },
    fullTextListBox: {
        '&.MuiBox-root': {
            width: '100%',
            border: '1px solid #87888d',
            height: 36,
            borderRadius: 5,
            padding: '11px 12px',
        },
        '& .MuiTypography-root': {
            fontSize: '0.875rem',
            lineHeight: '15px',
            letterSpacing: '-0.5px',
        }
    },
    iconButton:{
        padding: 0,
        '&:hover':{
            background: 'transparent'
        }
    },
    volumeIconButton: {
        padding: 0,
        position: 'absolute',
        right: 10,
        top: 5,
        '&:hover':{
            background: 'transparent'
        }
    },
    highlightTextBox: {
        border: '1px solid #87888d',
        borderRadius: 8,
        height: 150,
        position: 'relative',
        '&.MuiBox-root': {
            padding: '10px 13px',
        },
        '& .MuiTypography-root': {
            color: '#000',
            letterSpacing: '-0.2px',
            '& span': {
                background: 'rgba(242, 124, 87, 0.7)'
            }
        },
    },
    boldTextBox: {
        '& .MuiTypography-root': {
            color: '#000',
            letterSpacing: '-0.2px',
            '& span': {
                fontWeight: 'bold'
            }
        },
    },
    uncomplete: {
        marginRight: 30,
        '&.MuiBox-root': {
            padding: 0,
        },
        '& .MuiButtonBase-root': {
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
            minWidth: 56,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: 'rgba(255, 255, 255, 0.7)',
            }
        }
    },
    complete: {
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 56,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: '#fff',
            }
        }
    },
    boldUncomplete: {
        marginRight: 30,
        '&.MuiBox-root': {
            padding: 0,
        },
        '& .MuiButtonBase-root': {
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
            minWidth: 56,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: 'rgba(255, 255, 255, 0.7)',
            }
        }
    },
    boldComplete: {
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 82,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
                color: '#fff',
            }
        }
    },
    popoverTooltip: {
        '& .MuiPopover-paper': {
            background: '#365edf',
            color: '#fff',
            minWidth: 343,
            minHeight: 88,
            padding: '10px 10px 10px 15px',
            overflow: 'visible',
            marginTop: 15,
        },
        '& .MuiTypography-root': {
            color: '#fff',
            fontSize: '15px',
            lineHeight: '21px',
            letterSpacing: '-0.5px',
        }
    },
    tooltipTop: {
        position: 'absolute',
        top: -10,
        left: '50%',
        color: '#000'
    },
    tooltipBtn: {
        '& .MuiButtonBase-root': {
            padding: 0,
            minWidth: 'auto',
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    PaddingBox: {
        '& > .MuiBox-root': {
            padding: 0,
        }
    },
    buttonBox: {
        '&.MuiBox-root': {
            padding: 0,
        }
    },
    SpeakinWritingTitle: {
        marginBottom: 23,
        '& .MuiTypography-root': {
            fontSize: '0.938rem',
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
        },
        '& .MuiButtonBase-root': {
            minWidth: 'auto',
            padding: 0,
            '&:hover': {
                background: 'transparent'
            },
        }
    },
    langText: {
        '&.MuiTypography-root': {
            fontSize: '0.938rem',
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
            marginRight: 10,
        },
    },
    swichStyle: {
        '&.MuiSwitch-root': {
            padding: '10px 10px',
        },
        '& .MuiSwitch-switchBase': {
            color: '#fff',
        },
        '& .MuiSwitch-thumb': {
            width: 14,
            height: 14,
        },
        '& .MuiButtonBase-root': {
            paddingTop: '12px',
            paddingLeft: '12px',
        },
        '& .MuiSwitch-track': {
            borderRadius: 10,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            background: '#5579f0',
            opacity: 1
        }
    },
    textFieldBox: {
        marginTop: 10,
        '& .MuiFormControl-root': {
            width: '100%',
            height: 40,
            boxSizing: 'border-box',
            marginRight: 10,
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
    },
    nameList: {
        '&.MuiBox-root': {
            padding: 0,
        },
        '& > .MuiTypography-root': {
            width: 40,
            marginRight: 20,
            fontSize: '0.875rem',
            letterSpacing: '-0.4px',
            fontWeight: 'bold',
            boxSizing: 'border-box',
        }
    },
    heightStep3: {
        height: 'calc(100vh - 665px)',
        overflowX: 'auto'
    }

}));












